(() => {
  const pushEvent = (event, params = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  };

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const initLiveStorefrontFixes = () => {
    if (!document.getElementById('patitas-live-storefront-styles')) {
      const style = document.createElement('style');
      style.id = 'patitas-live-storefront-styles';
      style.textContent = `
        .pch-hero__subscriptions{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);grid-template-rows:minmax(300px,1.08fr) minmax(255px,.92fr);gap:14px;min-height:585px;align-self:stretch}
        .pch-sub-card{position:relative;min-width:0;overflow:hidden;border-radius:28px;color:#fff!important;text-decoration:none!important;isolation:isolate;background:#183d31;box-shadow:0 12px 36px rgba(23,54,43,.10)}
        .pch-sub-card--wide{grid-column:1/-1}.pch-sub-card>img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;transform:scale(1.001);transition:transform .45s ease}
        .pch-sub-card::after{content:'';position:absolute;inset:0;z-index:1;background:linear-gradient(180deg,rgba(7,22,17,.03) 24%,rgba(7,22,17,.74) 100%);pointer-events:none}.pch-sub-card:hover>img{transform:scale(1.035)}
        .pch-sub-card__badge{position:absolute;top:18px;left:18px;z-index:3;display:inline-flex;align-items:center;min-height:34px;padding:7px 13px;border-radius:999px;background:rgba(255,252,245,.94);color:#155d45;font-size:12px;line-height:1;font-weight:800;letter-spacing:.02em;backdrop-filter:blur(8px)}
        .pch-sub-card__copy{position:absolute;left:22px;right:22px;bottom:20px;z-index:2;color:#fff}.pch-sub-card__copy small{display:block;margin:0 0 5px;color:rgba(255,255,255,.82);font-size:11px;font-weight:800;letter-spacing:.12em}
        .pch-sub-card__copy h2,.pch-sub-card__copy h3{margin:0;color:#fff!important;line-height:1.02}.pch-sub-card__copy h2{font-size:clamp(29px,3vw,43px)}.pch-sub-card__copy h3{font-size:clamp(22px,2vw,29px)}
        .pch-sub-card__copy p{margin:8px 0 13px;max-width:420px;color:rgba(255,255,255,.9);font-size:14px;line-height:1.4}.pch-sub-card__meta{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:11px}.pch-sub-card__meta strong{color:#fff;font-size:19px;line-height:1}.pch-sub-card__meta span{color:#fff;font-size:13px;font-weight:800}
        @media (min-width:1200px){.pch-home .pch-product-grid{grid-template-columns:repeat(5,minmax(0,1fr))}}
        @media (max-width:850px){.pch-hero__subscriptions{min-height:520px;grid-template-rows:minmax(250px,1.05fr) minmax(230px,.95fr)}.pch-sub-card{border-radius:22px}.pch-sub-card__copy{left:17px;right:17px;bottom:16px}}
        @media (max-width:560px){.pch-hero__subscriptions{min-height:auto;grid-template-columns:1fr 1fr;grid-template-rows:250px 190px;gap:10px}.pch-sub-card{border-radius:20px}.pch-sub-card__badge{top:13px;left:13px;font-size:10px;min-height:30px}.pch-sub-card__copy{left:14px;right:14px;bottom:14px}.pch-sub-card__copy h2{font-size:28px}.pch-sub-card__copy h3{font-size:18px}.pch-sub-card__copy p{display:none}.pch-sub-card__meta{align-items:flex-end}.pch-sub-card__meta strong{font-size:15px}.pch-sub-card__meta span{font-size:11px}}
      `;
      document.head.appendChild(style);
    }

    const productGrid = document.querySelector('.pch-product-grid');
    if (productGrid) {
      const dedupeCrunchy = () => {
        const cards = Array.from(productGrid.querySelectorAll('.pch-product')).filter((card) => card.querySelector('a[href*="crunchy-paws-patitas-de-pollo"]'));
        cards.slice(1).forEach((card) => card.remove());
        const heading = productGrid.closest('.pch-products')?.querySelector('.pch-heading h2');
        if (heading && heading.textContent.includes('Cuatro')) heading.textContent = 'Cinco premios. Cinco formas de consentirlo.';
      };
      dedupeCrunchy();
      const observer = new MutationObserver(dedupeCrunchy);
      observer.observe(productGrid, { childList: true });
      window.addEventListener('load', dedupeCrunchy, { once: true });
    }

    document.querySelectorAll('.pnc-product__trust').forEach((trust) => {
      const middle = trust.children?.[1];
      if (middle) middle.innerHTML = '<strong>Bolsa resellable</strong><br>Cierre práctico';
    });

    const oldReturnCopy = 'Los productos sin abrir pueden solicitar devolución dentro de los 7 días posteriores a la entrega.';
    const newReturnCopy = 'Puedes solicitar una devolución dentro de los 7 días posteriores a la entrega, siempre que el producto permanezca sin abrir y cumpla las condiciones de devolución.';
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.includes(oldReturnCopy)) node.nodeValue = node.nodeValue.replace(oldReturnCopy, newReturnCopy);
    }
  };

  onReady(initLiveStorefrontFixes);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const galleryButton = event.target.closest('.pnc-product__thumbs [data-pnc-gallery-image]');
    if (!galleryButton) return;
    event.preventDefault();
    const gallery = galleryButton.closest('.pnc-product__gallery');
    const mediaMain = gallery?.querySelector('.pnc-product__media-main');
    const currentImage = mediaMain?.querySelector('img');
    const nextSrc = galleryButton.getAttribute('data-pnc-gallery-image');
    if (!mediaMain || !currentImage || !nextSrc) return;
    const nextImage = currentImage.cloneNode(false);
    nextImage.removeAttribute('srcset');nextImage.removeAttribute('sizes');nextImage.removeAttribute('width');nextImage.removeAttribute('height');
    nextImage.setAttribute('src', nextSrc);nextImage.setAttribute('srcset', nextSrc);nextImage.setAttribute('data-pnc-main-image', '');
    nextImage.alt = galleryButton.getAttribute('data-pnc-gallery-alt') || currentImage.alt || '';nextImage.loading = 'eager';nextImage.decoding = 'async';
    mediaMain.replaceChildren(nextImage);
    gallery.querySelectorAll('[data-pnc-gallery-image]').forEach((thumb) => { const active = thumb === galleryButton; thumb.classList.toggle('is-active', active); thumb.setAttribute('aria-current', active ? 'true' : 'false'); });
  }, true);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('[data-pnc-event]');
    if (target) pushEvent(`patitas_${target.dataset.pncEvent}`, { plan: target.dataset.plan || undefined, link_url: target.href || undefined, page_path: window.location.pathname });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form instanceof HTMLFormElement && form.action && form.action.includes('/cart/add')) pushEvent('patitas_add_to_cart', { page_path: window.location.pathname });
  });

  document.addEventListener('patitas:quiz-start', () => pushEvent('patitas_quiz_start', { page_path: window.location.pathname }));
  document.addEventListener('patitas:quiz-complete', (event) => pushEvent('patitas_quiz_complete', event.detail || {}));

  const productRoot = document.querySelector('[data-pnc-product]');
  if (productRoot) {
    const variantSelect = productRoot.querySelector('[data-pnc-variant-select]');
    const priceNode = productRoot.querySelector('[data-pnc-product-price]');
    const submitButton = productRoot.querySelector('[data-pnc-product-submit]');
    const dataNode = productRoot.querySelector('[data-pnc-variants-json]');
    if (variantSelect && dataNode) {
      try {
        const variants = JSON.parse(dataNode.textContent);
        variantSelect.addEventListener('change', () => {
          const variant = variants.find((item) => String(item.id) === String(variantSelect.value));
          if (!variant) return;
          if (priceNode) priceNode.textContent = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(variant.price / 100);
          if (submitButton) { submitButton.disabled = !variant.available; submitButton.textContent = variant.available ? 'Agregar al carrito' : 'No disponible'; }
          const url = new URL(window.location.href);url.searchParams.set('variant', variant.id);history.replaceState({}, '', url);
        });
      } catch (error) { console.warn('No se pudieron leer las variantes de producto.', error); }
    }
  }
})();
